import { render } from "./noticeEdit.vue?vue&type=template&id=0273e612&scoped=true"
import script from "./noticeEdit.vue?vue&type=script&lang=js"
export * from "./noticeEdit.vue?vue&type=script&lang=js"

import "./noticeEdit.vue?vue&type=style&index=0&id=0273e612&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0273e612"]])

export default __exports__